import React from 'react'

const Footer = () => {
  return (
    <div
      name="about"
      className="w-full bg-gray-800 text-white h-auto"
    >
      <div className="max-w-screen-lg px-2 py-4  mx-auto flex flex-col justify-center items-center w-full h-full">
          <h1 className='text-center text-gray-400 text-base font-semibold'>Made With ❤️ By Molla Mainuddin</h1>
          {/* <h1 className='text-center text-gray-400 text-sm font-semibold'>&copy; Copyright 2023, Created By Molla Mainuddin</h1> */}
      </div>
    </div>
  )
}

export default Footer;